export default "<ion-button (click)=\"didTapBack()\">\n  <ion-icon name=\"chevron-back-sharp\" slot=\"icon-only\"></ion-icon>\n</ion-button>\n";